/* eslint import/prefer-default-export: 0 */

const lazyCmpConfig = {
  loading: {
    template: "<div>Async loading!</div>"
  },
  error: {
    template: "<div>ERROR loading!</div>"
  },
  delay: 200,
  timeout: 10000
};

export const DashboardIndex = () => ({
  component: import("@/brapp/components/sections/dashboard/DashboardIndex/index"),
  ...lazyCmpConfig
});

export const BriefList = () => ({
  component: import("@/brapp/components/sections/briefs/BriefList/index"),
  ...lazyCmpConfig
});

export const CreateBrief = () => ({
  component: import("@/brapp/components/sections/briefs/CreateBrief/index"),
  ...lazyCmpConfig
});

export const EditBrief = () => ({
  component: import("@/brapp/components/sections/briefs/EditBrief/index"),
  ...lazyCmpConfig
});

export const BriefReport = () => ({
  component: import("@/brapp/components/sections/briefs/BriefReport/index"),
  ...lazyCmpConfig
});

export const AlertList = () => ({
  component: import("@/brapp/components/sections/alerts/AlertList/index"),
  ...lazyCmpConfig
});

export const CreateAlert = () => ({
  component: import("@/brapp/components/sections/alerts/CreateAlert/index"),
  ...lazyCmpConfig
});

export const EditAlert = () => ({
  component: import("@/brapp/components/sections/alerts/EditAlert/index"),
  ...lazyCmpConfig
});

export const IssueOverview = () => ({
  component: import("@/brapp/components/sections/issues/IssueOverview/index"),
  ...lazyCmpConfig
});

export const IssueList = () => ({
  component: import("@/brapp/components/sections/issues/IssueList/index"),
  ...lazyCmpConfig
});

export const IssueTypes = () => ({
  component: import("@/brapp/components/sections/issues/IssueTypes/index"),
  ...lazyCmpConfig
});

export const RecognitionOverview = () => ({
  component: import("@/brapp/components/sections/recognitions/RecognitionOverview/index"),
  ...lazyCmpConfig
});

export const RecognitionList = () => ({
  component: import("@/brapp/components/sections/recognitions/RecognitionList/index"),
  ...lazyCmpConfig
});

export const ReportsIndex = () => ({
  component: import("@/brapp/components/sections/reports/ReportsIndex/index"),
  ...lazyCmpConfig
});

export const ProductList = () => ({
  component: import("@/brapp/components/sections/sales/products/ProductList/index"),
  ...lazyCmpConfig
});

export const CreateProduct = () => ({
  component: import("@/brapp/components/sections/sales/products/CreateProduct/index"),
  ...lazyCmpConfig
});

export const EditProduct = () => ({
  component: import("@/brapp/components/sections/sales/products/EditProduct/index"),
  ...lazyCmpConfig
});

export const LocationList = () => ({
  component: import("@/brapp/components/sections/sales/locations/LocationList/index"),
  ...lazyCmpConfig
});

export const CreateLocation = () => ({
  component: import("@/brapp/components/sections/sales/locations/CreateLocation/index"),
  ...lazyCmpConfig
});

export const EditLocation = () => ({
  component: import("@/brapp/components/sections/sales/locations/EditLocation/index"),
  ...lazyCmpConfig
});

export const CategoryList = () => ({
  component: import("@/brapp/components/sections/sales/categories/CategoryList/index"),
  ...lazyCmpConfig
});

export const CreateCategory = () => ({
  component: import("@/brapp/components/sections/sales/categories/CreateCategory/index"),
  ...lazyCmpConfig
});

export const EditCategory = () => ({
  component: import("@/brapp/components/sections/sales/categories/EditCategory/index"),
  ...lazyCmpConfig
});

export const SalesOverview = () => ({
  component: import("@/brapp/components/sections/sales/dashboard/SalesOverview/index"),
  ...lazyCmpConfig
});
